"use server";

import { getQuoteFormOptionsCached } from "@/src/lib/api/fetch-quote-form-options";

export async function getQuoteFormOptions(locale: string) {
  return getQuoteFormOptionsCached(locale);
}
